import { checkForNull } from "../../helper/validation";

/**
* @method weightDoor
* @description Actual weight Door
*/
export const weightDoor = (fieldObj = {}, currentSelectedMaterial) => {

    let val
    let tempA, tempB, tempC, tempD

    //    =(I14 * (H4 + 100) * (I4 + 100) * Q387) 
    //    + (((I15 * (I17 - O131) * 1000 * Q387) * I19 * H4 / 1000) + ((O132 * O131 * 1000 * Q387) * I19 * H4 / 1000)) 
    //    + (((I16 * (I18 - O255) * 1000 * Q387) * I20 * I4 / 1000) + ((O256 * O255 * 1000 * Q387) * I20 * I4 / 1000)) 
    //    + (324 * 75 * 10 * Q387)

    const Q386 = currentSelectedMaterial && currentSelectedMaterial == 5 ? 0.00000265 :
        !currentSelectedMaterial && fieldObj.manufacturingMaterial == 5 ? 0.00000265 : 0.00000795

    if (currentSelectedMaterial == 5) {
        val = 0.00000265
    }
    else {
        val = 0.00000795
    }

    // 20-07-2021
    //    =(I14 * (H4 + 100) * (I4 + 100) * Q387) 
    
    tempA = checkForNull(Number(fieldObj.skinPlateThickness) * (checkForNull(Number(fieldObj.width)) + 100) * (checkForNull(Number(fieldObj.height)) + 100) * checkForNull(Number(val)))

    // (checkForNull(Number(fieldObj.skinPlateThickness))) * (checkForNull(Number(fieldObj.width + 100))) * (checkForNull(Number(fieldObj.height + 100))) * checkForNull(Number(val))
    // 8*1014*1014*0.00000265

    tempB = ((checkForNull(Number(fieldObj.HRt3)) * ((checkForNull(Number(fieldObj.horizontalRibsHeight))) -
        (checkForNull(Number(fieldObj.HRb1)))) * 1000 * (checkForNull(Number(val)))) * (checkForNull(Number(fieldObj.horizontalStiffeners))) *
        (checkForNull(Number(fieldObj.width))) / 1000) + (((checkForNull(Number(fieldObj.HRt1))) * (checkForNull(Number(fieldObj.HRb1))) * 1000 *
            (checkForNull(Number(val)))) * (checkForNull(Number(fieldObj.horizontalStiffeners))) * (checkForNull(Number(fieldObj.width))) / 1000)
    //    + (((I15 * (I17 - O131) * 1000 * Q387) * I19 * H4 / 1000) + ((O132 * O131 * 1000 * Q387) * I19 * H4 / 1000)) 
   
    tempC = ((((checkForNull(Number(fieldObj.VRt3))) * ((checkForNull(Number(fieldObj.vertiRibsHeight))) -
        (checkForNull(Number(fieldObj.VRb1)))) * 1000 * checkForNull(Number(val))) * ((checkForNull(Number(fieldObj.verticalStiffeners))) *
            (checkForNull(Number(fieldObj.height))) / 1000) + (((checkForNull(Number(fieldObj.VRt1))) * (checkForNull(Number(fieldObj.VRb1))) * 1000 *
                (checkForNull(Number(fieldObj.VRb1)))) * (checkForNull(Number(fieldObj.verticalStiffeners))) *
                (checkForNull(Number(fieldObj.height))) / 1000)))

    tempD = 324 * 75 * 10 * (checkForNull(Number(val)))
    //    + (324 * 75 * 10 * Q387)
  //     ((6.4 * (150 - 0.00) * 1000 * val) * 3 * 914 / 1000) + ((0.00 * 0.00 * 1000 * val) * 3 * 914 / 1000) + (324 * 75 * 10 * val), 'weightt final')

    // ____
    // let tempA = (checkForNull(Number(fieldObj.skinPlateThickness)) * (checkForNull(Number(fieldObj.height)) + 100) * (checkForNull(Number(fieldObj.width)) + 100) * 1.15 * 0.00000795);
    // let tempB = ((checkForNull(Number(fieldObj.HRt3)) * checkForNull(Number(fieldObj.horizontalRibsHeight)) * 1000 * 0.00000795) * 1.15 * checkForNull(Number(fieldObj.horizontalStiffeners)) * checkForNull(Number(fieldObj.width)) / 1000);
    // let tempC = ((checkForNull(Number(fieldObj.VRt3)) * checkForNull(Number(fieldObj.vertiRibsHeight)) * 1000 * 0.00000795) * 1.15 * checkForNull(Number(fieldObj.verticalStiffeners)) * checkForNull(Number(fieldObj.width)) / 1000);
    // let tempD = (324 * 75 * 10 * 0.00000795 * 1.15);

    // let tempA = (I4 * H4 + 100) * (I4 + 100) * 0.00000795);
    // let tempB = (I15 * I17 * 1000 * 0.00000795 * I19 * H4 / 1000);
    // let tempC = (I18 * I16 * 1000 * 0.00000795) * I20 * I4 / 1000);
    // let tempD = (324 * 75 * 10 * 0.00000795);

    // let tempA = (checkForNull(Number(fieldObj.skinPlateThickness)) * (checkForNull(Number(fieldObj.height)) + 100) * (checkForNull(Number(fieldObj.width)) + 100) * 0.00000795);
    // let tempB = ((checkForNull(Number(fieldObj.HRt3)) * checkForNull(Number(fieldObj.horizontalRibsHeight)) * 1000 * 0.00000795) * checkForNull(Number(fieldObj.horizontalStiffeners)) * checkForNull(Number(fieldObj.width)) / 1000);
    // let tempC = ((checkForNull(Number(fieldObj.VRt3)) * checkForNull(Number(fieldObj.vertiRibsHeight)) * 1000 * 0.00000795) * checkForNull(Number(fieldObj.verticalStiffeners)) * checkForNull(Number(fieldObj.width)) / 1000);
    // let tempD = (324 * 75 * 10 * 0.00000795);



    //28-09-2020  
    // let tempA = (checkForNull(Number(fieldObj.skinPlateThickness)) * (checkForNull(Number(fieldObj.height)) + 100) * (checkForNull(Number(fieldObj.width)) + 100) * Q386);

    // let tempB = ((checkForNull(Number(fieldObj.HRt3)) * checkForNull(Number(fieldObj.horizontalRibsHeight)) * 1000 * Q386) * checkForNull(Number(fieldObj.horizontalStiffeners)) * checkForNull(Number(fieldObj.width)) / 1000);

    // let tempC = ((checkForNull(Number(fieldObj.VRt3)) * checkForNull(Number(fieldObj.vertiRibsHeight)) * 1000 * Q386) * checkForNull(Number(fieldObj.verticalStiffeners)) * checkForNull(Number(fieldObj.height)) / 1000);

    // let tempD = (324 * 75 * 10 * Q386);

    const weight = tempA + tempB + tempC + tempD;
    // 
    // 
    // 
    // 
    // 
    // 
    // 
    // 
    // 
    // 
    // 
    // 
    // 
    // 
    // 
    // 

    // const weight = (checkForNull(Number(fieldObj.skinPlateThickness)) * (checkForNull(Number(fieldObj.height)) + 100) * (checkForNull(Number(fieldObj.width)) + 100) * 1.15 * 0.00000795) +
    //     ((checkForNull(Number(fieldObj.HRt3)) * checkForNull(Number(fieldObj.HRd1)) * 1000 * 0.00000795) * 1.15 * checkForNull(Number(fieldObj.horizontalStiffeners)) * checkForNull(Number(fieldObj.width)) / 1000) +
    //     ((checkForNull(Number(fieldObj.VRt3)) * checkForNull(Number(fieldObj.VRd1)) * 1000 * 0.00000795) * 1.15 * checkForNull(Number(fieldObj.verticalStiffeners)) * checkForNull(Number(fieldObj.width)) / 1000) +
    //     (324 * 75 * 10 * 0.00000795 * 1.15)
    return checkForNull(weight);
}